import { AutoMap } from "@automapper/classes"
import { EMilieuPrelevementSurface } from "./enum/milieu-prelevement"
import { Prelevement } from "../prelevement"
import { mapper } from "src/app/tools/mapping/mapper"
import { PrelevementSurfaceDTO } from "src/app/services/dto/prelevement-surface.dto"
import { ELieuPrelevementSurface } from "./enum/lieu-prelevement"
import { BaseDOM } from "../base.dom"
import { Appareil } from "../Qualif/appareil"

export class PrelevementSurface extends BaseDOM<PrelevementSurface> {
    @AutoMap()
    Code: string = ''
    @AutoMap()
    LieuPrelevement: ELieuPrelevementSurface = ELieuPrelevementSurface.Autre
    @AutoMap()
    AutreLieuPrelevement: string = ''
    @AutoMap()
    MilieuPrelevement: EMilieuPrelevementSurface = EMilieuPrelevementSurface.BoiteContact
    @AutoMap()
    Observations: string = ''
    @AutoMap()
    Prelevement: Prelevement = new Prelevement();


    //** For UI Only */
    SearchText: string = ''
}